// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-muted[data-v-334c7ecc]{color:#999}a[data-v-334c7ecc]{text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
